/**
 * Lifecycle of a synchronized GIM order in Okto
 */
export enum GimOrderState {
  /** Synchronized from GIM, not yet created in Multipress */
  TO_PROCESS = 'to_process',
  /** Created in Multipress */
  PROCESSED = 'processed',
  /** Hidden from the orders list */
  ARCHIVED = 'archived',
}
